import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { StanleyIconSvg, OneAppIcon } from '../index';

const MobileAppIcon = ({ classes, isOneAppIconEnabled }) => {
  return isOneAppIconEnabled ? (
    <OneAppIcon className={classes.icon} />
  ) : (
    <StanleyIconSvg className={cx(classes.icon, classes.yellowIcon)} />
  );
};

MobileAppIcon.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  isOneAppIconEnabled: PropTypes.bool,
};

MobileAppIcon.defaultProps = {
  classes: {},
};
export default MobileAppIcon;
